import type {
  CustomizeRequest,
  SelectedDoors,
  SelectedModelVersion,
  SelectedTrim,
  SelectedTruckBodyStyle,
  SelectedYear
} from '~/contracts/new-cars';
import type { ConfiguratorState } from './configuratorState';

export type ConfiguratorAction =
  | { type: 'CLEAR_DOORS' }
  | { type: 'CLEAR_MODEL_VERSION' }
  | { type: 'CLEAR_OPTIONS' }
  | { type: 'CLEAR_TRIM' }
  | { type: 'CLEAR_TRUCK_BODY_STYLE' }
  | { type: 'CLEAR_YEAR' }
  | { type: 'RESTORE_FROM_HISTORY'; payload: ConfiguratorState }
  | { type: 'SELECT_DOORS'; payload: SelectedDoors }
  | { type: 'SELECT_MODEL_VERSION'; payload: SelectedModelVersion }
  | { type: 'SELECT_TRIM'; payload: SelectedTrim }
  | { type: 'SELECT_TRUCK_BODY_STYLE'; payload: SelectedTruckBodyStyle }
  | { type: 'SELECT_YEAR'; payload: SelectedYear }
  | { type: 'SET_OPTIONS'; payload: CustomizeRequest }
  | { type: 'START_OVER' };

export default function configuratorReducer(
  state: ConfiguratorState,
  action: ConfiguratorAction
): ConfiguratorState {
  switch (action.type) {
    case 'CLEAR_DOORS':
      return {
        ...state,
        selectedDoors: null,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null
      };

    case 'CLEAR_MODEL_VERSION':
      return {
        ...state,
        selectedDoors: null,
        selectedModelVersion: null,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null
      };

    case 'CLEAR_OPTIONS':
      return { ...state, selectedOptions: null };

    case 'CLEAR_TRIM':
      return {
        ...state,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null
      };

    case 'CLEAR_TRUCK_BODY_STYLE':
      return { ...state, selectedOptions: null, selectedTruckBodyStyle: null };

    case 'CLEAR_YEAR':
      return {
        selectedDoors: null,
        selectedModelVersion: null,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null,
        selectedYear: null
      };

    case 'RESTORE_FROM_HISTORY': {
      const restored = action.payload;

      return {
        selectedDoors: restored.selectedDoors
          ? state.selectedDoors ?? restored.selectedDoors
          : null,
        selectedModelVersion: restored.selectedModelVersion
          ? state.selectedModelVersion ?? restored.selectedModelVersion
          : null,
        selectedOptions: restored.selectedOptions
          ? state.selectedOptions ?? restored.selectedOptions
          : null,
        selectedTrim: restored.selectedTrim
          ? state.selectedTrim ?? restored.selectedTrim
          : null,
        selectedTruckBodyStyle: restored.selectedTruckBodyStyle
          ? state.selectedTruckBodyStyle ?? restored.selectedTruckBodyStyle
          : null,
        selectedYear: restored.selectedYear
          ? state.selectedYear ?? restored.selectedYear
          : null
      };
    }

    case 'SELECT_DOORS':
      return {
        ...state,
        selectedDoors: action.payload,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null
      };

    case 'SELECT_MODEL_VERSION':
      return {
        ...state,
        selectedDoors: null,
        selectedModelVersion: action.payload,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null
      };

    case 'SELECT_TRIM':
      return {
        ...state,
        selectedOptions: action.payload.isConfigurationComplete
          ? { ...action.payload }
          : null,
        selectedTrim: action.payload,
        selectedTruckBodyStyle: null
      };

    case 'SELECT_TRUCK_BODY_STYLE':
      return {
        ...state,
        selectedOptions: { ...action.payload },
        selectedTruckBodyStyle: action.payload
      };

    case 'SELECT_YEAR':
      return {
        ...state,
        selectedDoors: null,
        selectedModelVersion: null,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null,
        selectedYear: action.payload
      };

    case 'SET_OPTIONS':
      return { ...state, selectedOptions: action.payload };

    case 'START_OVER':
      return {
        selectedDoors: null,
        selectedModelVersion: null,
        selectedOptions: null,
        selectedTrim: null,
        selectedTruckBodyStyle: null,
        selectedYear: null
      };
  }
}
